'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errors = require('../errors.js');

var utils = require('../utils.js');

var Service = /*#__PURE__*/function () {
  function Service(activate, deactivate) {
    _classCallCheck(this, Service);

    this.activate = activate;
    this.deactivate = deactivate;
    this.state = {
      status: 'stopped'
    };
  }

  _createClass(Service, [{
    key: "use",
    value: function () {
      var _use = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Service.use(this, options);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function use(_x) {
        return _use.apply(this, arguments);
      }

      return use;
    }()
  }, {
    key: "try",
    value: function _try() {
      return Service.try(this);
    }
  }], [{
    key: "create",
    value: function create(_ref) {
      var start = _ref.start,
          stop = _ref.stop;
      return new Service(start, stop);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(service, options) {
        var state, activate, promise, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = service.state, activate = service.activate;
                _context2.t0 = state.status;
                _context2.next = _context2.t0 === 'stopped' ? 4 : _context2.t0 === 'starting' ? 18 : _context2.t0 === 'started' ? 19 : _context2.t0 === 'stopping' ? 20 : 25;
                break;

              case 4:
                _context2.prev = 4;
                promise = activate(options);
                service.state = {
                  status: 'starting',
                  ready: promise
                };
                _context2.next = 9;
                return promise;

              case 9:
                result = _context2.sent;
                service.state = {
                  status: 'started',
                  value: result
                };
                return _context2.abrupt("return", result);

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](4);
                service.state = {
                  status: 'stopped'
                };
                throw _context2.t1;

              case 18:
                throw new errors.AlreadyStartingError();

              case 19:
                throw new errors.AlreadyStartedError();

              case 20:
                _context2.next = 22;
                return state.ready;

              case 22:
                _context2.next = 24;
                return Service.start(service, options);

              case 24:
                return _context2.abrupt("return", _context2.sent);

              case 25:
                return _context2.abrupt("return", Service.panic(service));

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 14]]);
      }));

      function start(_x2, _x3) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(service) {
        var state, deactivate;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = service.state, deactivate = service.deactivate;
                _context3.t0 = state.status;
                _context3.next = _context3.t0 === 'stopped' ? 4 : _context3.t0 === 'starting' ? 5 : _context3.t0 === 'stopping' ? 15 : _context3.t0 === 'started' ? 18 : 23;
                break;

              case 4:
                return _context3.abrupt("break", 24);

              case 5:
                _context3.prev = 5;
                _context3.next = 8;
                return state.ready;

              case 8:
                _context3.next = 12;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t1 = _context3["catch"](5);

              case 12:
                _context3.next = 14;
                return Service.stop(service);

              case 14:
                return _context3.abrupt("return", _context3.sent);

              case 15:
                _context3.next = 17;
                return state.ready;

              case 17:
                return _context3.abrupt("return", _context3.sent);

              case 18:
                if (!deactivate) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 21;
                return deactivate(state.value);

              case 21:
                service.state = {
                  status: 'stopped'
                };
                return _context3.abrupt("break", 24);

              case 23:
                Service.panic(state);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 10]]);
      }));

      function stop(_x4) {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "try",
    value: function _try(_ref2) {
      var state = _ref2.state;

      switch (state.status) {
        case 'started':
          return state.value;

        default:
          return null;
      }
    }
  }, {
    key: "use",
    value: function () {
      var _use2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3, options) {
        var state;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = _ref3.state;
                _context4.t0 = state.status;
                _context4.next = _context4.t0 === 'started' ? 4 : _context4.t0 === 'starting' ? 5 : 8;
                break;

              case 4:
                return _context4.abrupt("return", state.value);

              case 5:
                _context4.next = 7;
                return utils.withTimeout(state.ready, options);

              case 7:
                return _context4.abrupt("return", _context4.sent);

              case 8:
                throw new errors.NotStartedError();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function use(_x5, _x6) {
        return _use2.apply(this, arguments);
      }

      return use;
    }()
  }, {
    key: "panic",
    value: function panic(_ref4) {
      var state = _ref4.state;
      var status = JSON.stringify({
        status: state.status
      });
      throw RangeError("Service in invalid state ".concat(status, ", should never happen if you see this please report a bug"));
    }
  }]);

  return Service;
}();

exports.Service = Service;